export const iconFontAwesomeAlphabetK = (
	<i className="fa-solid fa-k"></i>
);
